module.exports = __webpack_public_path__ + "img/md_main_img-s.8dbe08b8.png";